import { Component, HostListener, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthentificationService } from '../authentification/authentification.service';
import { RolesService } from '../authentification/roles.service';
import { SpinnerService } from '../core/spinner.service';
import { FormulaireService } from '../saisie/formulaire.service';
import { ModeRenduService } from '../saisie/mode-rendu/mode-rendu.service';
import { FiltreService } from '../shared/filtre.service';
import { butEnquete, contactBcps, contactBis } from '../shared/questionnaire.metadata';

@Component({
  selector: 'bis-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  @Input()
  title: string;
  contactBis: { mail: string, tel: string } = contactBis;
  contactBcps: { mail: string, tel: string } = contactBcps;
  enDev = environment.dev;
  enProd = environment.production;
  /** Permet de savoir si la navbar doit être petite ou non */
  public navBarShrink: boolean = false;

  constructor(
    public formulaireService: FormulaireService,
    public AUTH: AuthentificationService,
    public ROLES: RolesService,
    public modeRenduService: ModeRenduService,
    public spinner: SpinnerService,
    public filtreService: FiltreService
  ) {

   }

  @HostListener('window:scroll', ['$event'])
  scrollHandler(event) {
    if (window.pageYOffset > 0) {
      this.navBarShrink = true;
    } else if (window.pageYOffset === 0) {
      this.navBarShrink = false;
    }
  }

  cliqueSeDeconnecter() {
    if (confirm('Êtes-vous sûr de vouloir vous déconnecter ? Toutes données non enregistrées seront perdues.')) {
      this.formulaireService.effacerQuestionnaire();
      this.AUTH.logout();
    }
  }
  
  ngOnInit() {
  }
  
  get butEnquete() {
    return butEnquete;
  }
  
  get version() {
    return environment.version;
  }
  
}
